// Query string slugs for the sale details tabs, in display order.
export const SaleDetailsTabSlugs = [
    "sale-details",
    "parcel-management",
    "parcel-order",
    "approved-bidders",
    "reminders",
    "watchers",
    "saved-search-sends"
] as const;

export type SaleDetailsTabSlug = (typeof SaleDetailsTabSlugs)[number];

// Tabs from this index on are hidden while creating a sale.
const FirstSavedSaleTab = 3;
const TabParam = "tab";

export const saleDetailsTabSearch = (tab: SaleDetailsTabSlug) =>
    `?${TabParam}=${tab}`;

export const parseSaleDetailsTab = (search: string, isCreate: boolean) => {
    const slug = new URLSearchParams(search).get(TabParam);
    const index = SaleDetailsTabSlugs.indexOf(slug as SaleDetailsTabSlug);
    const visibleTabCount = isCreate
        ? FirstSavedSaleTab
        : SaleDetailsTabSlugs.length;
    return index > 0 && index < visibleTabCount ? index : 0;
};

export const withSaleDetailsTab = (search: string, index: number) => {
    const params = new URLSearchParams(search);
    if (index > 0) {
        params.set(TabParam, SaleDetailsTabSlugs[index]);
    } else {
        params.delete(TabParam);
    }
    const query = params.toString();
    return query ? `?${query}` : "";
};
